<template>
  <h1 class="text-lg font-extrabold leading-6 text-green-100">
    <slot />
  </h1>
</template>
